import { AutogenModelEdiCommodity, AutogenRowEdiCommodity } from "./autogen/AutogenModelEdiCommodity";

export class ModelEdiCommodity extends AutogenModelEdiCommodity<RowEdiCommodity> {
	constructor() {
		super(RowEdiCommodity);
	}
}

export class RowEdiCommodity extends AutogenRowEdiCommodity {
}